import { createFileRoute } from '@tanstack/react-router';

import { Feed } from '#modules/user/features/dashboard/components/Feed';

export const Route = createFileRoute('/{-$locale}/_layout/_dashboard/_authed/dashboard/')({
  component: Feed,
});
